import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";
import router from "@/router";

export const useAuthStore = defineStore("auth", () => {
  const token = ref(localStorage.getItem("token"));
  const user = ref(JSON.parse(localStorage.getItem("user")));
  const defaultPasword = "mily1234";
  // const API_URL_IMAGES = process.env.VUE_APP_API_URL_IMAGES;

  // const API_URL = "http://localhost/mily-backend/api/endpoints/";
  // const API_URL_IMAGES = "http://localhost/mily-backend";
  const API_URL = "https://milyssalonybarberaz.com/mily-backend/api/endpoints/";
  const API_URL_IMAGES = "https://milyssalonybarberaz.com/mily-backend";

  async function login(username, password) {
    try {
      // process.env.VUE_APP_API_URL + "login.php",
      const { data } = await axios.post(
        API_URL + "login.php",
        {
          username,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('login->',{data});
      
      token.value = data.token;
      // Aquí decodificaríamos el token para obtener los datos del usuario
      // const decodedToken = JSON.parse(atob(data.token.split(".")[1]));
      user.value = {
        id: data.user.id,
        nombre: data.user.nombre,
        username: data.user.username,
        rol: data.user.rol,
        // Agrega otros campos que necesites del token
      };
      localStorage.setItem("token", token.value);
      localStorage.setItem("user", JSON.stringify(user.value));
      if (password == defaultPasword) {
        return { changePassword: true };
      }
      router.push("/dashboard");
    } catch (error) {
      console.error("Error en login:", error);
      throw new Error("Usuario o contraseña incorrectos");
    }
  }
  
  function logout() {
    token.value = null;
    user.value = null;
    localStorage.clear();
    router.push("/login");
  }

  return {
    token,
    user,
    login,
    logout,
    API_URL_IMAGES,
  };
});
